var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDispenser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 28,
    viewBox: "0 0 19 28",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2432_4278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0895 28H17.1615C17.2435 28 17.3222 27.9688 17.3802 27.9132C17.4381 27.8577 17.4707 27.7823 17.4707 27.7038V26.5318H17.6388C18.0001 26.531 18.3463 26.3929 18.6015 26.1478C18.8567 25.9028 19 25.5708 19 25.2247V2.30719C19 1.96106 18.8567 1.62906 18.6015 1.384C18.3463 1.13895 18.0001 1.00085 17.6388 1H1.36459C1.00273 1.00015 0.655758 1.13796 0.399966 1.38314C0.145259 1.62896 0.00161167 1.96084 0 2.30719V25.2247C0.00161167 25.571 0.145259 25.9029 0.399966 26.1487C0.655758 26.3939 1.00273 26.5317 1.36459 26.5318H1.53264V27.7038C1.53263 27.7818 1.56475 27.8567 1.62202 27.9121C1.67928 27.9676 1.75706 27.9992 1.83848 28H4.90378C4.98521 27.9992 5.06298 27.9676 5.12025 27.9121C5.17751 27.8567 5.20963 27.7818 5.20963 27.7038V26.5318H13.8005V27.7038C13.7997 27.7428 13.8074 27.7815 13.8231 27.8175C13.8387 27.8535 13.8619 27.886 13.8912 27.9131C13.9481 27.9682 14.0254 27.9994 14.1063 28H14.0895ZM16.8456 27.4108H14.3954V26.5318H16.8456V27.4108ZM4.59118 27.4108H2.14099V26.5318H4.59455L4.59118 27.4108ZM4.90041 25.9459H1.36459C1.16549 25.945 0.974861 25.8687 0.834395 25.7335C0.69393 25.5983 0.615076 25.4154 0.615078 25.2247V2.30719C0.614635 2.21263 0.633695 2.11891 0.671164 2.03143C0.708632 1.94395 0.763768 1.86442 0.833411 1.79741C0.903053 1.73039 0.985821 1.67723 1.07698 1.64094C1.16813 1.60466 1.26587 1.58598 1.36459 1.58598H17.6321C17.8312 1.58683 18.0218 1.66319 18.1623 1.79835C18.3027 1.93351 18.3816 2.11647 18.3816 2.30719V25.2247C18.3803 25.4149 18.302 25.5973 18.1631 25.7334C18.0933 25.8 18.0105 25.8527 17.9193 25.8887C17.8282 25.9246 17.7306 25.9429 17.6321 25.9426L4.90041 25.9459Z",
    fill: "current",
    stroke: "current",
    strokeWidth: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 15.9993V5.00388C15.9983 4.73826 15.8954 4.4841 15.7139 4.29675C15.6245 4.20256 15.5178 4.1278 15.4003 4.07685C15.2827 4.0259 15.1565 3.99978 15.029 4H3.96792C3.71195 4.00247 3.46714 4.10903 3.28613 4.29676C3.10513 4.48449 3.00238 4.7384 3 5.00388V15.9178C3 15.994 3.02918 16.0671 3.08113 16.121C3.13307 16.1748 3.20352 16.2051 3.27698 16.2051C3.35044 16.2051 3.4209 16.1748 3.47284 16.121C3.52479 16.0671 3.55397 15.994 3.55397 15.9178V5.00388C3.55234 4.94645 3.56184 4.88926 3.58191 4.8357C3.60198 4.78215 3.63222 4.73331 3.67082 4.6921C3.70943 4.65088 3.75561 4.61813 3.80665 4.59577C3.85768 4.57341 3.91252 4.5619 3.96792 4.56192H15.0199C15.0762 4.56055 15.1322 4.57103 15.1845 4.59273C15.2369 4.61444 15.2844 4.64691 15.3243 4.6882C15.3644 4.72933 15.3959 4.77859 15.4168 4.8329C15.4378 4.88721 15.4477 4.94542 15.446 5.00388V16.0119C15.446 16.0681 15.4353 16.1238 15.4144 16.1757C15.3936 16.2276 15.3631 16.2748 15.3246 16.3144C15.2861 16.354 15.2405 16.3853 15.1903 16.4065C15.14 16.4278 15.0863 16.4385 15.0321 16.4381H3.96792C3.9137 16.4385 3.85994 16.4278 3.80973 16.4065C3.75952 16.3853 3.71387 16.354 3.67539 16.3144C3.63692 16.2748 3.60637 16.2276 3.58553 16.1757C3.56469 16.1238 3.55397 16.0681 3.55397 16.0119V15.0459C3.55397 14.9697 3.52479 14.8966 3.47284 14.8428C3.4209 14.7889 3.35044 14.7586 3.27698 14.7586C3.20352 14.7586 3.13307 14.7889 3.08113 14.8428C3.02918 14.8966 3 14.9697 3 15.0459V16.0119C3.00477 16.2751 3.10876 16.526 3.28968 16.7107C3.4706 16.8954 3.71406 16.9992 3.96792 17H15.0199C15.2764 16.9984 15.522 16.8922 15.7036 16.7043C15.8853 16.5165 15.9885 16.2621 15.9909 15.9961L16 15.9993Z",
    fill: "current",
    stroke: "current",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3779 21.8308V20.0806C15.3762 19.872 15.2921 19.6724 15.1439 19.5249C14.9956 19.3774 14.795 19.2937 14.5853 19.292H13.5084C13.4277 19.292 13.3503 19.3239 13.2932 19.3807C13.2361 19.4375 13.204 19.5145 13.204 19.5948C13.204 19.6751 13.2361 19.7521 13.2932 19.8089C13.3503 19.8657 13.4277 19.8976 13.5084 19.8976H14.5853C14.6341 19.8976 14.6809 19.9169 14.7154 19.9512C14.7499 19.9855 14.7693 20.032 14.7693 20.0806V21.8308C14.7693 21.8793 14.7499 21.9259 14.7154 21.9602C14.6809 21.9945 14.6341 22.0138 14.5853 22.0138H4.42142C4.37264 22.0138 4.32585 21.9945 4.29135 21.9602C4.25686 21.9259 4.23748 21.8793 4.23748 21.8308V20.0806C4.23748 20.032 4.25686 19.9855 4.29135 19.9512C4.32585 19.9169 4.37264 19.8976 4.42142 19.8976H9.94986C10.0306 19.8976 10.108 19.8657 10.1651 19.8089C10.2221 19.7521 10.2542 19.6751 10.2542 19.5948C10.2542 19.5145 10.2221 19.4375 10.1651 19.3807C10.108 19.3239 10.0306 19.292 9.94986 19.292H4.42142C4.2112 19.292 4.00959 19.3751 3.86094 19.523C3.71229 19.6709 3.62878 19.8714 3.62878 20.0806V21.8308C3.62878 22.0399 3.71229 22.2405 3.86094 22.3884C4.00959 22.5363 4.2112 22.6194 4.42142 22.6194H14.5887C14.7983 22.6176 14.9989 22.534 15.1472 22.3865C15.2955 22.239 15.3795 22.0394 15.3813 21.8308H15.3779Z",
    fill: "current",
    stroke: "current",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2375 19.2787C11.1618 19.2866 11.0918 19.322 11.0409 19.3783C10.99 19.4345 10.9618 19.5075 10.9618 19.5831C10.9618 19.6588 10.99 19.7318 11.0409 19.788C11.0918 19.8442 11.1618 19.8797 11.2375 19.8876H12.0869C12.1626 19.8797 12.2326 19.8442 12.2835 19.788C12.3344 19.7318 12.3626 19.6588 12.3626 19.5831C12.3626 19.5075 12.3344 19.4345 12.2835 19.3783C12.2326 19.322 12.1626 19.2866 12.0869 19.2787H11.2375Z",
    fill: "current",
    stroke: "current",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.3,
    y: 6.3,
    width: 3.4,
    height: 3.4,
    rx: 0.7,
    stroke: "current",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.3,
    y: 6.3,
    width: 3.4,
    height: 3.4,
    rx: 0.7,
    stroke: "current",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.3,
    y: 6.3,
    width: 3.4,
    height: 3.4,
    rx: 0.7,
    stroke: "current",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.3,
    y: 11.3,
    width: 3.4,
    height: 3.4,
    rx: 0.7,
    stroke: "current",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.3,
    y: 11.3,
    width: 3.4,
    height: 3.4,
    rx: 0.7,
    stroke: "current",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.3,
    y: 11.3,
    width: 3.4,
    height: 3.4,
    rx: 0.7,
    stroke: "current",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3,
    y: 6.3,
    width: 3.4,
    height: 3.4,
    rx: 0.7,
    stroke: "current",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3,
    y: 6.3,
    width: 3.4,
    height: 3.4,
    rx: 0.7,
    stroke: "current",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3,
    y: 6.3,
    width: 3.4,
    height: 3.4,
    rx: 0.7,
    stroke: "current",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3,
    y: 11.3,
    width: 3.4,
    height: 3.4,
    rx: 0.7,
    stroke: "current",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3,
    y: 11.3,
    width: 3.4,
    height: 3.4,
    rx: 0.7,
    stroke: "current",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3,
    y: 11.3,
    width: 3.4,
    height: 3.4,
    rx: 0.7,
    stroke: "current",
    strokeWidth: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2432_4278"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 28,
    fill: "current"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispenser);
export default __webpack_public_path__ + "static/media/Dispenser.fca8f6fc80ebdfe7e2eed511b749760c.svg";
export { ForwardRef as ReactComponent };